// src/components/MenuDetail.jsx
import React from "react";
import Button1 from "@material-ui/core/Button";

function Field({ label, value, mono, isUrl }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <span style={{
        fontSize:      11,
        color:         "#64748b",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        fontWeight:    600,
      }}>
        {label}
      </span>
      <span style={{
        fontSize:    14,
        color:       isUrl ? "#1d4ed8" : "#1e293b",
        fontFamily:  mono ? "monospace" : "inherit",
        padding:     "5px 0",
        borderBottom: "1px solid #f1f5f9",
      }}>
        {value ?? "—"}
      </span>
    </div>
  );
}

export function MenuDetail({ menu, allMenus, onEdit, onDelete }) {
  if (!menu) {
    return (
      <div style={{
        flex:           1,
        display:        "flex",
        flexDirection:  "column",
        alignItems:     "center",
        justifyContent: "center",
        gap:            10,
        color:          "#94a3b8",
        padding:        40,
      }}>
        <i className="ti ti-layout-navbar" style={{ fontSize: 44, opacity: 0.25 }} />
        <p style={{ fontSize: 13 }}>Select a menu item to view details</p>
      </div>
    );
  }

  const parent = menu.MENU_PARENT_ID
    ? allMenus.find(m => m.MENU_ID === menu.MENU_PARENT_ID)
    : null;

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
      {/* Header */}
      <div style={{
        padding:       "14px 20px",
        borderBottom:  "1px solid #e2e8f0",
        display:       "flex",
        alignItems:    "flex-start",
        justifyContent: "space-between",
        gap:           12,
      }}>
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", margin: 0 }}>
            {menu.MENU_ICON && (
              <i className={`ti ${menu.MENU_ICON}`} style={{ marginRight: 8, opacity: 0.6, fontSize: 16 }} />
            )}
            {menu.MENU_TEXT}
          </h2>
          <span style={{ fontSize: 12, color: "#64748b", fontFamily: "monospace" }}>
            {menu.MENU_CODE}
          </span>
        </div>
        <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
          <Button1
            variant="outlined"
            size="small"
            onClick={onEdit}
            style={{ textTransform: "none", fontSize: 12 }}
          >
            ✏️ Edit
          </Button1>
          <Button1
            variant="outlined"
            size="small"
            onClick={onDelete}
            style={{
              textTransform: "none",
              fontSize:      12,
              borderColor:   "#fca5a5",
              color:         "#dc2626",
            }}
          >
            🗑️ Delete
          </Button1>
        </div>
      </div>

      {/* Detail grid */}
      <div style={{ padding: "20px", overflowY: "auto", flex: 1 }}>
        <div style={{
          display:             "grid",
          gridTemplateColumns: "1fr 1fr",
          gap:                 16,
        }}>
          <Field label="Menu code"  value={menu.MENU_CODE} mono />
          <Field label="Sequence"   value={menu.MENU_SEQ} />
          <Field label="Menu name"  value={menu.MENU_TEXT} />
          <Field label="Level"      value={`Level ${menu.MENU_LEVEL}`} />
          <Field label="Parent"     value={parent ? parent.MENU_TEXT : "(top-level)"} />
          <Field label="Status"     value={
            <span style={{
              fontSize:     11,
              padding:      "2px 8px",
              borderRadius: 10,
              fontWeight:   700,
              background:   menu.MENU_ACTIVE ? "#dcfce7" : "#f1f5f9",
              color:        menu.MENU_ACTIVE ? "#16a34a" : "#94a3b8",
            }}>
              {menu.MENU_ACTIVE ? "Active" : "Inactive"}
            </span>
          } />

          {/* Full-width fields */}
          <div style={{ gridColumn: "1 / -1" }}>
            <Field label="Description" value={menu.DESCRIPTION} />
          </div>
          <div style={{ gridColumn: "1 / -1" }}>
            <Field label="URL" value={menu.MENU_URL} isUrl mono />
          </div>
          <div style={{ gridColumn: "1 / -1" }}>
            <Field label="Icon" value={
              menu.MENU_ICON ? (
                <span style={{ display: "flex", alignItems: "center", gap: 8, fontFamily: "monospace", fontSize: 13 }}>
                  <i className={`ti ${menu.MENU_ICON}`} style={{ fontSize: 18 }} />
                  {menu.MENU_ICON}
                </span>
              ) : null
            } />
          </div>
        </div>
      </div>
    </div>
  );
}
